import { KlaviyoForm } from '@theme/klaviyo-form';

class KlaviyoSubscriptionForm extends KlaviyoForm {
  get #emailInput() {
    return this.querySelector('input[type="email"]');
  }

  get #phoneInput() {
    return this.querySelector('input[type="tel"]');
  }

  get #nameInput() {
    return this.querySelector('input[name="name"]');
  }

  get #formElement() {
    return this.querySelector('[data-ref="form"]')
  }

  get #successElement() {
    return this.querySelector('[data-ref="success"]')
  }

  async onFormSubmit() {
    const email = this.#emailInput?.value?.trim();
    const phoneNumber = this.#phoneInput?.value?.trim();
    const { firstName, lastName } = this.#splitName(this.#nameInput?.value?.trim());

    if (!email) {
      this.renderMessage('error', Theme.strings.klaviyo.errors.email_missing);
      return;
    }

    if (!this.listId) {
      this.renderMessage('error', Theme.strings.klaviyo.errors.generic);
      return;
    }

    try {
      const response = await this.#createClientSubscription(
        { email, phoneNumber, firstName, lastName }
      );

      if (!response.ok) {
        const data = await response.json();

        this.renderMessage('error',
          data?.errors?.[0]?.detail ?? Theme.strings.klaviyo.errors.generic
        );

        return;
      }

      this.#handleSuccess();
    } catch (error) {
      this.renderMessage('error', Theme.strings.klaviyo.errors.generic);
    }
  }

  #createClientSubscription({ email, phoneNumber, firstName, lastName }) {
    const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${this.publicApiKey}`;

    const profileAttributes = {
      email,
      subscriptions: {
        email: {
          marketing: {
            consent: 'SUBSCRIBED'
          }
        }
      }
    };

    if (phoneNumber) {
      profileAttributes.phone_number = phoneNumber;
      profileAttributes.subscriptions.sms = {
        marketing: {
          consent: 'SUBSCRIBED'
        }
      };
    }

    if (firstName) {
      profileAttributes.first_name = firstName;
    }

    if (lastName) {
      profileAttributes.last_name = lastName;
    }

    return fetch(url, {
      method: 'POST',
      headers: {
        revision: '2026-01-15',
        'content-type': 'application/vnd.api+json'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            ...(this.customSource && { custom_source: this.customSource }),
            profile: {
              data: {
                type: 'profile',
                attributes: profileAttributes
              }
            }
          },
          relationships: {
            list: {
              data: { type: 'list', id: this.listId }
            }
          }
        }
      })
    });
  }

  #splitName(fullName = '') {
    const parts = fullName.trim().split(/\s+/);

    return {
      firstName: parts[0] || '',
      lastName: parts.slice(1).join(' ') || '',
    };
  }

  #handleSuccess() {
    const successElement = this.#successElement;

    if (!successElement) {
      this.renderMessage('success', Theme.strings.klaviyo.success.generic);
      return;
    }

    this.#formElement.classList.add('hidden');
    successElement.classList.remove('hidden');
  }
}

if (!customElements.get('klaviyo-subscription-form')) {
  customElements.define('klaviyo-subscription-form', KlaviyoSubscriptionForm);
}
